import { Button } from '@/components/ui';
import { cn } from '@/lib';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { useRouter } from 'next/navigation';
import React from 'react';

interface CategoryDetailsProps {
  heading: string;
  subHeading: string;
  colorScheme?: 'dark' | 'light';
  nextSlide?: () => void;
  prevSlide?: () => void;
  buttonRedirect?: string;
}

const CategoryDetails = ({
  heading,
  subHeading,
  colorScheme,
  nextSlide,
  prevSlide,
  buttonRedirect
}: CategoryDetailsProps) => {
  const router = useRouter();

  return (
    <div className='flex items-center justify-between px-3'>
      <div>
        <p
          className={cn(
            ' xs:text-2xl ml-1 text-base font-extrabold xs:font-bold sm:text-xl',
            {
              'text-white': colorScheme === 'dark',
              'text-gray-800': colorScheme === 'light',
            },
          )}
        >
          {heading}
        </p>
      </div>
     <div
        className={cn('flex items-center', {
          '': !buttonRedirect, 
          'border-zinc-700': colorScheme === 'dark' && !buttonRedirect,
          'border-zinc-200': colorScheme === 'light' && !buttonRedirect,
        })}
      >
<div className={cn('flex border rounded-2xl overflow-hidden',{
        'border-zinc-700': colorScheme === 'dark',
        'border-zinc-200': colorScheme === 'light',
      })}>
        <Button
          onClick={prevSlide}
          variant='ghost'
          aria-label='Previous'
          className={cn(
            'size-8 rounded-none text-white',
            {
              'border-zinc-700 text-[#c7c7c7]': colorScheme === 'dark',
              'bg-transparent text-zinc-700': colorScheme === 'light',
            },
          )}
        >
          <ChevronLeft strokeWidth={2} size={200} className='size-4' />
        </Button>
        <div className={cn('h-8 w-[1px] border-r ',{
          'border-zinc-700': colorScheme === 'dark',
          'border-zinc-200': colorScheme === 'light',
        })} />
        <Button
          onClick={nextSlide}
          variant='ghost'
          aria-label='Next'
          className={cn(
            'size-8 rounded-none text-white',
            {
              'border-zinc-700 text-[#c7c7c7]': colorScheme === 'dark',
              'bg-transparent text-zinc-700': colorScheme === 'light',
            },
          )}
        >
          <ChevronRight strokeWidth={2} size={200} className='size-4' />
        </Button>
        
      </div>
      <div>{buttonRedirect === '/allEvents' && (
          <Button
            onClick={() => router.push(buttonRedirect)}
            variant="outline"
            className={cn('h-8 ml-2 px-3 text-sm font-medium rounded-xl bg-gray-950 border-zinc-200 text-white hover:bg-transparent hover:text-gray-950')
            }
          >
            Explore More
          </Button>
        )}</div>
      </div>
      

    </div>
  );
}

export default CategoryDetails;
